<template>
  <div>
    <!-- BARRA SUPERIOR -->
    <v-app-bar app height="53" width="unzised">
      <!-- El mini permite establecer el sidebar en miniatura -->
      <v-app-bar-nav-icon @click.stop="mini = !mini"></v-app-bar-nav-icon>
      <v-spacer></v-spacer>

      <!-- Iconos de la barra superior -->
      <!-- Estos iconos se van a generar de manera dinamica. El usuario va a poder configurar sus preferencias y establecer
      los accesos directos en el navbar -->
      <!-- <v-tooltip
        bottom
        class="mr-5"
        v-for="item in preferenciasAccesosDirectos"
        v-bind:key="item.text"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon>
            <v-icon dark v-bind="attrs" v-on="on"> {{ item.icon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ item.tooltip }}</span>
      </v-tooltip> -->
      <!--FIN  Iconos de la barra superior -->
      <!-- <v-spacer></v-spacer> -->

      <!-- Icono para cambiar el theme a modo oscuro o claro -->
      <!-- Los colores del tema debe ir especificados en la instancia de vuetify -->
      <v-btn icon v-if="!$vuetify.theme.dark" @click="cambiarTheme()">
        <v-icon class="mr-1" color="blue-grey darken-4">mdi-lightbulb</v-icon>
      </v-btn>
      <v-btn icon v-if="$vuetify.theme.dark" @click="cambiarTheme()">
        <v-icon color="yellow darken-3">mdi-lightbulb-outline</v-icon>
      </v-btn>
      <!-- Icono para cambiar el theme a modo oscuro o claro -->

      <!--MENU DE USUARIO (Ubicado en el appbar)-->
      <div class="text-center">
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="100"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn text v-bind="attrs" v-on="on">
              {{ nombreUsuario }}
            </v-btn>
          </template>

          <v-card elevation="1">
            <v-list>
              <v-list-item>
                <!-- IMAGEN DE PERFIL USUARIO -->
                <v-list-item-avatar>
                  <img :src="imagenPerfil" alt="imagenPerfil" />
                </v-list-item-avatar>

                <!-- NOMBRE Y CARGO DEL USUARIO -->
                <v-list-item-content>
                  <v-list-item-title>{{ nombreUsuario }}</v-list-item-title>
                  <v-list-item-subtitle>{{
                    cargoUsuario
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <!--FIN NOMBRE Y CARGO DEL USUARIO -->

                <!-- BOTÓN PARA CERRAR EL DROWNMENU DEL USUARIO -->
                <v-list-item-action>
                  <v-btn color="red" icon @click="menu = false">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-list-item-action>
                <!-- FIN BOTÓN PARA CERRAR EL DROWNMENU DEL USUARIO -->
              </v-list-item>
            </v-list>

            <v-list>
              <!-- LINK PARA CONFIGURACIONES -->
              <v-divider></v-divider>
              <v-list-item link @click="dirigirAPerfil">
                <v-list-item-icon>
                  <v-icon>mdi-cog-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Configuración</v-list-item-title>
                  <v-list-item-subtitle
                    >Perfil Usuario- Accesos directos</v-list-item-subtitle
                  >
                </v-list-item-content>
              </v-list-item>

              <v-divider></v-divider>

              <!-- LINK PARA CERRAR SESIÓN -->
              <v-list-item link>
                <v-list-item-icon>
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Cerrar Sesión</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </div>
      <!-- FIN MENU DE USUARIO -->

      <!--BOTÓN DRAWERN RIGTH -->
      <!-- Este botón permite desplegar el sidebar derecho que contiene eventos, notas y fecha -->
      <!-- <v-btn text @click.stop="drawer_right = !drawer_right">
        <v-icon>mdi-menu-open</v-icon>
      </v-btn> -->
      <!--BOTÓN DRAWERN RIGTH -->
    </v-app-bar>
    <!-- FIN BARRA SUPERIOR -->

    <!-- SIDEBAR PRINCIPAL-->
    <v-navigation-drawer
      app
      v-model="drawer"
      :mini-variant.sync="mini"
      permanent
      dark
      class="bg-navigation-drawer"
    >
      <!-- CONTENIDO DEL SIDEBAR -->

      <!-- Cabecera -->
      <v-list-item class="px-2">
        <v-list-item-avatar class="p-3">
          <v-img :src="imagenPerfil"></v-img>
        </v-list-item-avatar>

        <v-list-item-title
          ><h2>{{ nombreUsuario }}</h2></v-list-item-title
        >
      </v-list-item>
      <!-- Fin Cabecera -->

      <v-divider></v-divider>

      <!-- LISTAS ANIDADAS -->
      <v-list>
        <!-- Home -->
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-home</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item>
        <!-- Fin home -->

        <!-- Listas desplegables -->
        <v-list-group :value="true" no-action prepend-icon="mdi-account-circle">
          <template v-slot:activator>
            <v-list-item-title>Clientes</v-list-item-title>
          </template>

          <v-list-item router :to="{ path: 'registrar-usuario' }" class="ml-n9">
            <v-list-item-icon>
              <v-icon v-text="'mdi-account-plus'"></v-icon>
            </v-list-item-icon>
            <v-list-item-title
              class="ml-n4"
              v-text="'Registrar Usuario'"
            ></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- Fin sublistas -->

        <!-- Fin de lista desplegable -->

        <v-list-group :value="false" no-action prepend-icon="mdi-tools">
          <template v-slot:activator>
            <v-list-item-title>Equipos</v-list-item-title>
          </template>

          <v-list-item router :to="{ path: '/' }" class="ml-n9">
            <v-list-item-icon>
              <v-icon v-text="'mdi-file-edit'"></v-icon>
            </v-list-item-icon>
            <v-list-item-content class="ml-n5">
              <v-list-item-title> Hoja de vida </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!-- Sublistas -->
          <v-list-group :value="true" sub-group>
            <template v-slot:activator>
              <v-list-item-content> Mantenimiento </v-list-item-content>
            </template>

            <v-list-item @click="$router.push({ name: 'mantenimiento' })">
              <v-list-item-icon>
                <v-icon v-text="'mdi-wrench-clock'"></v-icon>
              </v-list-item-icon>
              <v-list-item-title
                align="center"
                v-text="'Registrar Mantenimiento'"
              ></v-list-item-title>
            </v-list-item>
            <div>
              <v-list-item
                v-if="crearMantenimiento"
                @click="$router.push({ name: 'registrar-actividad' })"
              >
                <v-list-item-icon>
                  <v-icon :v-text="'mdi-clipboard-list'"></v-icon>
                </v-list-item-icon>
                <v-list-item-title :v-text="'Actividades'"></v-list-item-title>
              </v-list-item>
            </div>
          </v-list-group>
          <!-- Fin sublistas -->
        </v-list-group>

        <v-list-group
          :value="false"
          no-action
          prepend-icon="mdi-clipboard-check-outline"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title class="d-flex text-wrap"   v-text="'Chequeo Sensorial'"
                ></v-list-item-title
              >
            </v-list-item-content>
          </template>

          <v-list-item router :to="{ path: '/sensorial-inspector' }" class="ml-n9">
            <v-list-item-icon>
              <v-icon>mdi-clipboard-edit-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="ml-n4"
              >Sensorial Inspector</v-list-item-title
            >
          </v-list-item>

          <v-list-item router :to="{ path: '/revision-sensorial' }" v-if="!$store.state.roles_hermes.includes('inspector')"  class="ml-n9">
            <v-list-item-icon>
              <v-icon>mdi-clipboard-check-multiple-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="ml-n4"
              >Revisión Sensorial</v-list-item-title
            >
          </v-list-item>

          <v-list-item router :to="{ path: '/consultar-sensorial' }" v-if="!$store.state.roles_hermes.includes('inspector')" class="ml-n9">
            <v-list-item-icon>
              <v-icon>mdi-text-box-search-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="ml-n4"
              >Consultar Sensorial</v-list-item-title
            >
          </v-list-item>

          <v-list-item router :to="{ path: '/config-sensorial' }" v-if="!$store.state.roles_hermes.includes('inspector')" class="ml-n9">
            <v-list-item-icon>
              <v-icon>mdi-cog</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="ml-n4"
              >Config Sensioral</v-list-item-title
            >
          </v-list-item>
          <v-list-item router :to="{ path: '/informe-sensorial' }" v-if="!$store.state.roles_hermes.includes('inspector')" class="ml-n9">
            <v-list-item-icon>
              <v-icon>mdi-chart-bar</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="ml-n4"
              >Informe Servicios</v-list-item-title
            >
          </v-list-item>
        </v-list-group>

        <v-list-group
          :value="true"
          no-action
          prepend-icon="mdi-email-newsletter"
        >
          <template v-slot:activator>
            <v-list-item-title>PQRS</v-list-item-title>
          </template>

          <v-list-item router :to="{ path: '/consultar-pqrs' }" class="ml-n9">
            <v-list-item-icon>
              <v-icon>mdi-text-box-search-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title class="ml-n4">Consultar PQRS</v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
      <!-- LISTAS ANIDADAS -->

      <!-- LISTA UNICA -->
      <!-- <v-list>
        <v-list-group
          v-for="item in items"
          :key="item.title"
          v-model="item.active"
          :prepend-icon="item.action"
          no-action
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.title"></v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item v-for="child in item.items" :key="child.title">
            <v-list-item-content>
              <v-list-item-title v-text="child.title"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>
      </v-list> -->
      <!-- LISTA UNICA -->
    </v-navigation-drawer>
    <!-- FIN SIDEBAR PRINCIPAL -->

    <!-- SIDEBAR DERECHO -->
    <template>
      <v-navigation-drawer
        color="grey lighten-4"
        v-model="drawer_right"
        width="320px"
        absolute
        temporary
      >
        <v-list-item>
          <v-list-item-avatar>
            <v-img :src="imagenPerfil"></v-img>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ nombreUsuario }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <!-- FECHA -->
        <div class="container mx-5">
          <v-row class="">
            <v-col cols="12" class="pa-0 ma-0 mb-0 mt-3">
              <v-label>Hoy</v-label>
            </v-col>
            <v-col cols="12" class="pa-0 ma-0 mb-0 mt-3">
              <p class="dia ma-0">{{ dia }}</p>
            </v-col>
            <v-col cols="12" class="pa-0 ma-0 mb-3">
              <p class="fecha ma-0">{{ fecha }}</p>
            </v-col>
          </v-row>
        </div>
        <!--FIN FECHA -->

        <v-divider></v-divider>

        <!-- EVENTOS -->
        <div class="container mx-4">
          <v-row class="">
            <v-col cols="12" class="pa-0 ma-0 mb-0 mt-2">
              <v-label>Eventos</v-label>
            </v-col>

            <v-col
              cols="12"
              class="pa-0 ma-0 mb-0"
              v-for="evento in eventos"
              :key="evento.titulo"
            >
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>{{ evento.titulo }} </v-list-item-title>
                  <v-list-item-subtitle>{{
                    evento.texto
                  }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </div>
        <!-- FIN EVENTOS -->
        <v-divider></v-divider>

        <!-- NOTAS -->
        <div class="container mx-4">
          <v-row class="">
            <v-col cols="12" class="pa-0 ma-0 mb-0 mt-2">
              <v-label>Notas</v-label>
            </v-col>
            <v-col
              cols="12"
              class="pa-0 ma-0 mb-0"
              v-for="nota in notas"
              :key="nota.titulo"
            >
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title>{{ nota.titulo }}</v-list-item-title>
                  <v-list-item-subtitle>{{ nota.texto }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
          </v-row>
        </div>
        <!-- FIN NOTAS -->

        <v-divider></v-divider>
      </v-navigation-drawer>
    </template>
    <!-- FIN SIDEBAR DERECHO -->

    <!-- ROUTERVIEW -->
    <!-- <router-view /> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      nombreUsuario: "Mitchel Oviedo",
      cargoUsuario: "Medico",
      crearMantenimiento: false,
      mini: true,
      //variables boton menu usuario
      imagenPerfil:
        "data:image/jpeg;base64,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",
      menu: false,
      drawer_right: false,
      drawer: true,

      //  VARIABLES SIDEBAR DERECHO
      dia: "Lunes",
      fecha: "20 de Diciembre",
      eventos: [
        { titulo: "Titulo1", texto: "Texto evento" },
        { titulo: "Titulo2", texto: "Texto evento2" },
      ],
      notas: [{ titulo: "Nota1", texto: "texto nota" }],

      // VARIABLES SIDEBAR PRINCIPAL (ejemplo)
      admins: [
        ["Item1", "mdi-account-multiple-outline"],
        ["Item2", "mdi-cog-outline"],
      ],
      items: [
        {
          action: "mdi-briefcase",
          items: [{ title: "List Item" }],
          title: "Office",
        },
      ],

      preferenciasAccesosDirectos: [
        {
          icon: "mdi-home",
          text: "home",
          tooltip: "home",
        },
      ],
    };
  },
  beforeCreate() {
    for (var i = 0; i < this.$store.permisos; i++) {
      if (this.$store.permisos[i] == "mantenimiento.crearMantenimiento") {
        this.crearMantenimiento == true;
      }
    }
  },
  methods: {
    cambiarTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
    },
    dirigirAPerfil() {
      this.$router.push({ path: "perfil-usuario" });
    },
  },
};
</script>

<style scoped>
.bg-navigation-drawer {
  background-color: #0f172a !important;
}

/* ESTILOS SIDEBAR DERECHO */
.fecha {
  font-size: 2em;
  color: rgb(136, 135, 135);
}

.dia {
  font-size: 1.5em;
  color: rgb(83, 82, 82);
}
</style>
